import { useState } from "react";

import ProjectsDesktopItem from "./ProjectsDesktopItem";
import ArrowRight from "../LogoSVG/ArrowRight";

import netcompanyLogo from "../../public/netcompany.png";
import thumbnailThesis from "../../public/thumbnail-thesis.png";
import thumbnailNFTMarket from "../../public/thumbnail-nftmarket.png";
import thumbnailAIC from "../../public/thumbnail-aic24.png";
import thumbnailDiffusion from "../../public/thumbnail-diffusion.png";
import thumbnail2D3D from "../../public/thumbnail-2d-3d.png";
import thumbnailPorfolio from "../../public/thumbnailPortfolio.png";
import thumbnaulCommitVuln from "../../public/mockup.png";

function ProjectsDesktop() {
  const [hoveredIndex, setHoveredIndex] = useState<number>();
  const [hoverArrow, setHoverArrow] = useState<boolean>(false);

  return (
    <section id="projects" className="pt-[80px]">
      <div className="container items-start">
        <div className="flex items-center">
          <p className="text-[24px] font-medium mb-8">Pinned Projects</p>
        </div>

        {/* <div>
          <a
            className="flex flex-row flex-wrap  text-custom-green items-center mb-4"
            onMouseEnter={() => setHoverArrow(true)}
            onMouseLeave={() => setHoverArrow(false)}
            href="/full-projects"
          >
            <div
              className={`text-lg mr-2  ${
                hoverArrow === true ? "underline underline-offset-4" : ""
              }`}
            >
              View Full Project Archive
            </div>
            <ArrowRight
              isYellow
              className={`transition-transform duration-300 ease-in-out ${
                hoverArrow === true ? "translate-x-3 " : ""
              }`}
            />
          </a>
        </div> */}

        <div className="flex flex-row">
          <ProjectsDesktopItem
            hoveredIndex={hoveredIndex}
            setHoveredIndex={setHoveredIndex}
            thumbnail={thumbnailThesis}
            highLight
            title="An Intelligent Digital Diary"
            description="A smart app to transform traditional journaling through innovative functionalities."
            url="/projects/thesis"
            index={1}
            listTech={["JavaScript", "Python", "Django", "Django", "Django"]}
          />

          <ProjectsDesktopItem
            hoveredIndex={hoveredIndex}
            setHoveredIndex={setHoveredIndex}
            thumbnail={thumbnaulCommitVuln}
            title="GitHub Commit Vulnerability Prediction"
            description="An end-to-end ML pipeline for predicting insecure code files in GitHub commits."
            url="/projects/commit-vulnerability-predictor"
            index={4}
          />

          <ProjectsDesktopItem
            hoveredIndex={hoveredIndex}
            setHoveredIndex={setHoveredIndex}
            thumbnail={thumbnailNFTMarket}
            title="NFT Marketplace"
            description="A trading NFT platform on the Ethereum network."
            url="https://github.com/lnqminh3003/AuraSky-NFT-Marketplace"
            index={2}
            listTech={["JavaScript", "Python", "Django", "Django", "Django"]}
          />
        </div>

        <div className="flex flex-row mb-4">
          {/* <ProjectsDesktopItem
            hoveredIndex={hoveredIndex}
            setHoveredIndex={setHoveredIndex}
            thumbnail={thumbnailDiffusion}
            title="Stable Diffusion Web Application"
            description="AI-generated image website with Replicate, Web3 API, and Firebase Storage."
            url="https://github.com/lnqminh3003/cs422-ai-diffusion-web-application"
            index={4}
            listTech={["JavaScript", "Python", "Django", "Django", "Django"]}
          /> */}

          <ProjectsDesktopItem
            hoveredIndex={hoveredIndex}
            setHoveredIndex={setHoveredIndex}
            thumbnail={thumbnailAIC}
            title="Event Querying from Videos"
            description="A system for querying frames within a 1,400-video dataset."
            url="https://github.com/lnqminh3003/hcm-AI-challenge-2024"
            index={3}
          />

          <ProjectsDesktopItem
            hoveredIndex={hoveredIndex}
            setHoveredIndex={setHoveredIndex}
            thumbnail={thumbnail2D3D}
            title="From 2D Image to 3D Model"
            description="A script using Python and Blender API to convert 2D nature images into 3D models."
            url="https://github.com/lnqminh3003/transform-2D-image-to-3D-model"
            index={5}
            listTech={["JavaScript", "Python", "Django", "Django", "Django"]}
          />

          {/* <ProjectsDesktopItem
            hoveredIndex={hoveredIndex}
            setHoveredIndex={setHoveredIndex}
            thumbnail={thumbnailPorfolio}
            title="Personal Portfolio Website"
            description="A responsive portfolio site built with React.js and Tailwind CSS."
            url="https://minh-le.vercel.app/"
            index={6}
            listTech={["JavaScript", "Python", "Django", "Django", "Django"]}
          /> */}
        </div>
      </div>
    </section>
  );
}

export default ProjectsDesktop;
